define(['edge/platform/base/BaseCtrl'], (BaseCtrl)=> {
    const fn = function ($scope, $element) {
        function setElementVisibility(isVisible) {
            $scope.sideBarMenuVisible = isVisible;
            $element.toggleClass('gw-slidebar-menu-open', isVisible);
        }

        const ctrl = Object.create(BaseCtrl);

        ctrl.init = ()=> {
            $scope.sideBarMenuVisible = false;
        };

        ctrl.toggleSideBarMenu = ()=> {
            setElementVisibility(!$scope.sideBarMenuVisible);
        };

        ctrl.hideSideBarMenu = ()=> {
            setElementVisibility(false);
        };

        ctrl.showSideBarMenu = ()=> {
            setElementVisibility(true);
        };

        ctrl.isSideBarMenuVisible = ()=> {
            return $scope.sideBarMenuVisible;
        };

        return ctrl.create($scope);
    };

    fn.$inject = ['$scope', '$element'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/wizard/NavBarWizardBaseCtrl.js
 **/